import { useState } from 'react';
import { UserPropsType } from '../../../../../Types/Application/Users/UsersProfile'
import { Col, Media, Row } from 'reactstrap'
import { H5 } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Service'
import { useAuth } from '../../../../../hooks/useAuth'
import { useTranslation } from 'react-i18next'

const CommonProfileHead = ({ activeTime }: UserPropsType) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [imageError, setImageError] = useState(false);

  // Obtener foto del usuario o usar imagen por defecto
  const defaultImage = dynamicImage('user/7.jpg');
  const userPhoto = (user?.photo_url && !imageError) ? user.photo_url : defaultImage;

  // Obtener nombre del usuario
  const userName = user?.name || user?.email || t("Usuario");

  // Formatear fecha de creación del usuario
  const formatCreatedDate = () => {
    if (!user?.created_at) return activeTime || t("Miembro desde hace tiempo");
    try {
      const createdDate = new Date(user.created_at);
      const now = new Date();
      const diffTime = Math.abs(now.getTime() - createdDate.getTime());
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays < 30) {
        return `${t("Miembro desde hace")} ${diffDays} ${diffDays === 1 ? t("día") : t("días")}`;
      } else if (diffDays < 365) {
        const months = Math.floor(diffDays / 30);
        return `${t("Miembro desde hace")} ${months} ${months === 1 ? t("mes") : t("meses")}`;
      } else {
        const years = Math.floor(diffDays / 365);
        return `${t("Miembro desde hace")} ${years} ${years === 1 ? t("año") : t("años")}`;
      }
    } catch (error) {
      return activeTime || t("Miembro desde hace tiempo");
    }
  };

  return (
    <Row>
      <Col sm="8">
        <Media>
          <img
            className="img-thumbnail rounded-circle me-3"
            src={userPhoto}
            alt={userName}
            onError={() => setImageError(true)}
            style={{ width: '50px', height: '50px', objectFit: 'cover' }}
          />
          <Media body className="align-self-center">
            <H5 className="mt-0 user-name">{userName}</H5>
          </Media>
        </Media>
      </Col>
      <Col sm="4" className="align-self-center">
        <div className="float-sm-end">
          <small>{formatCreatedDate()}</small>
        </div>
      </Col>
    </Row>
  )
}

export default CommonProfileHead